import { computed, observable } from "mobx";
import StoreBase from "../../StoreBase";
import axios from "axios";
import { words as RouteWords } from '../../../../resource/data/APIRoutes.json'
import ManufactureWork from "../../../model/manufacture/ManufactureWork";
import ManufactureItem from "../../../model/manufacture/ManufactureItem";

export class PackingListSummaryWorks extends ManufactureWork {
    shippingDateStr?: string;
}

export class ManufacturePackagingListRowData {
    shippingRequestDate?: Date;
    boxNO?: string;
    works?: PackingListSummaryWorks[]

    @observable isSelected: boolean = false;
    @observable index: number = 0;

    constructor(data?: ManufacturePackagingListRowData, index?: number) {
        if (data) {
            this.shippingRequestDate = data.shippingRequestDate;
            this.boxNO = data.boxNO;
            this.works = data.works.map(v => {
                const d = new PackingListSummaryWorks();
                d.fromJSWithDate(v);
                d.shippingDateStr = v.shippingDateStr;
                d.itemList = v.itemList.map(i => {
                    const item = new ManufactureItem({ optionReadonly: true });
                    item.fromJS(i);
                    return item;
                })
                return d;
            });
        };
        if (!!index && index > 0) this.index = index;
    }
}

class ManufacturePackagingListStore extends StoreBase {
    @observable data?: ManufacturePackagingListRowData[] = [];

    @computed get numSelected() {
        return this.data?.filter(v => v.isSelected).length ?? 0;
    }

    async requestPackagingListData(token: string) {
        const config = {
            headers: {
                'x-access-token': token,
            }
        }
        return axios.get(
            `${this.baseURL}/${RouteWords.auth}/${RouteWords.pts}/${RouteWords.api}/${RouteWords.version2}/${RouteWords.manufacture}/${RouteWords.list}/${RouteWords.packagingList}`,
            config,
        ).then((res) => {
            return res;
        }).catch((err) => {
            throw err;
        });
    }

    selectAll = (selected: boolean) => {
        this.data?.forEach(v => v.isSelected = selected);
    }

    async setPackagingListData(token: string) {
        const result = await this.requestPackagingListData(token);
        // @ts-ignore
        this.data = result.data.data.map((v, i) => new ManufacturePackagingListRowData(v, i + 1));
    }
}

export default ManufacturePackagingListStore;